import React from "react";
import BrotherPlusDeviceStats from "../../../../components/CustomerDashboard/BrotherPlus/BrotherPlusDeviceStats/BrotherPlusDeviceStats";
import BrotherPlusPagesUsed from "../../../../components/CustomerDashboard/BrotherPlus/BrotherPlusPagesUsed/BrotherPlusPagesUsed";
import SupplyLevels from "../../../../components/CustomerDashboard/SupplyLevels/SupplyLevels";
import BrotherPlusPrintActivity from "../../../../components/CustomerDashboard/BrotherPlus/BrotherPlusPrintActivity/BrotherPlusPrintActivity";
import DiscountTile from "../../../../components/CustomerDashboard/BrotherPlus/DiscountTile/DiscountTile";
import { DISPLAY_CONTENT_TYPE } from "../Dashboard";
import { SOURCE_MY_DEVICE } from "../../../MyDevices/components/SuppliesComponent";
import PrinterIcon from "../../../../assets/images/printer-icon.svg";
import SectionHeader from "../../../MyDevices/components/SectionHeader/SectionHeader";
import { useTranslation } from "react-i18next";

const HybridLayout = (props) => {
    const { BPlusTileInfo } = props;
    const {
        source,
        deviceResponse: getDevicesResponse,
        deviceStatus,
        printHistoryInfo
    } = BPlusTileInfo
    const {t} = useTranslation(["translation"])
    return (
        <div>
            <div className="brother-plus-device-stats">
                {
                    (source && source === SOURCE_MY_DEVICE)
                        ? <SectionHeader
                            imageSrc={PrinterIcon}
                            title={t("MY_DEVICES.BROTHER_CONNECT_FEATURES")}
                            bgcolor="#cce6e9"
                            fontColor="#008393"
                        />
                        : <BrotherPlusDeviceStats></BrotherPlusDeviceStats>
                }
            </div>
            <div className="ecorpo-brother-plus-dashboard-wrapper">
                <div className="tile tile-3">
                    <div className="box">
                        <BrotherPlusPagesUsed
                            getDeviceStatusResponse={deviceStatus}
                            displayContent={DISPLAY_CONTENT_TYPE.pagesUsedCount}
                        />
                    </div>
                    <div className="box">
                        <BrotherPlusPagesUsed
                            getDeviceStatusResponse={deviceStatus}
                            displayContent={DISPLAY_CONTENT_TYPE.duplexPagesCount}
                        />
                    </div>
                </div>
                {
                    source === SOURCE_MY_DEVICE ?
                        null :
                        <div className="tile tile-4">
                            <SupplyLevels
                                getDeviceStatusResponse={deviceStatus}
                                isChildComp={true}
                                getDevicesResponse={getDevicesResponse}
                            />
                        </div>
                }
                <div className={`${source === SOURCE_MY_DEVICE ? "tile tile-7" : "tile tile-1"}`}>
                    <BrotherPlusPrintActivity
                        showAvgPagesUsed={true}
                        isChildComp={true}
                        BrotherPlus_printHistoryResult={printHistoryInfo}
                    />
                </div>
                {
                    source === SOURCE_MY_DEVICE ?
                        <div className="tile tile-8">
                            <div className="box">
                                <DiscountTile />
                            </div>
                        </div> :
                        <div className="tile tile-2">
                            <DiscountTile />
                        </div>
                }
            </div>
        </div>
    )
}

export default HybridLayout;